import React from 'react'
import Grid from '@mui/material/Grid2';
import { Divider, Typography } from '@mui/material';
import BlankCard from 'src/components/shared/BlankCard';
import ViewClientVoucherInformation from './ViewClientVoucherInformation';
import GenerateVoucher from './GenerateVoucher';

const ManageClientVoucherInformation = ({ isView, setError }) => {
    return (
        <Grid container spacing={0}>
            <Grid item size={12}>
                <BlankCard>
                    <Grid container alignItems="center">
                        <Grid item size={6}>
                            <Typography variant="h5" m={2}> {isView ? "View" : ""} Client Vouchers </Typography>
                        </Grid>
                        <Grid item size={6} textAlign={'right'} px={2}>
                            <GenerateVoucher setError={setError} />
                        </Grid>
                    </Grid>
                    <Divider />
                    {isView ? <ViewClientVoucherInformation /> : ""}
                </BlankCard>
            </Grid>
        </Grid>
    )
}

export default ManageClientVoucherInformation